import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Alert, Col, UncontrolledTooltip } from 'reactstrap';

export const handleShowColor = (status, type) => {
  if (type === 'label') {
    switch (status) {
      case 'COME_BACK_LATER':
        return 'Voltar mais tarde!';
      case 'VISITED':
        return 'Visitado';
      default:
        return 'Não visitado';
    }
  }

  switch (status) {
    case 'COME_BACK_LATER':
      return 'warning';
    case 'VISITED':
      return 'success';
    default:
      return 'danger';
  }
};

export function StatusClient({ status, size }) {
  const isMobileDevice = useMediaQuery({
    query: '(max-width: 990px)',
  });

  const handleMarginTop = () => {
    return isMobileDevice ? { marginTop: '0px' } : { marginTop: '20px' };
  };

  return (
    <Col lg={size}>
      <Alert
        style={{ textAlign: 'center', ...handleMarginTop() }}
        color={handleShowColor(status, 'color')}
      >
        {handleShowColor(status, 'label')}
      </Alert>
    </Col>
  );
}

export const CircleStatus = ({ status }) => {
  const statusCache = React.useMemo(() => status, [status]);

  let color = '';
  if (statusCache === 'COME_BACK_LATER') {
    color = '#fc7c5f';
  } else if (statusCache === 'VISITED') {
    color = '#4fd69c';
  } else if (statusCache === 'UNVISITED') {
    color = '#f75676';
  }

  const handleTitle = () => {
    if (statusCache === 'COME_BACK_LATER') {
      return 'Voltar mais tarde';
    } else if (statusCache === 'VISITED') {
      return 'Visitado';
    } else if (statusCache === 'UNVISITED') {
      return 'Não visitado';
    }
  };

  const randomString = Array.from({ length: 10 }, () =>
    String.fromCharCode(Math.floor(Math.random() * 26) + 97)
  ).join('');

  return (
    <div
      href='#'
      id={randomString + status}
      style={{
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        backgroundColor: color,
      }}
    >
      <UncontrolledTooltip
        target={randomString + status}
        trigger='hover'
        placement='right'
      >
        {handleTitle()}
      </UncontrolledTooltip>
    </div>
  );
};
